import { Dispatch, SetStateAction } from 'react';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import DefaultHereMap from '../../../DefaultHereMap';
import NoData from '../../../NoData';
import { SecondaryButton } from '../../../SecondaryButton';
import { SectionOptionType, TrajetoSelecaoIda, TrajetoSelecaoVolum, TrajetosIda, TrajetosVolum, ValeTransp } from '../../types';
import GeneralSummary from './components/GeneralSummary';
import PredefinedOptions from './components/PredefinedOptions';
import SidebarRoute from './components/SidebarRoute';
import { ViewType } from './components/SidebarRoute/types';
import { Container, MapContainer } from './styles';

interface IResult {
  goingRoute: TrajetoSelecaoIda[];
  returningRoute: TrajetoSelecaoVolum[];  resultHeaderWidth: number | null;
  otherGoingOptions: TrajetosIda[];
  otherReturningOptions: TrajetosVolum[];
  handleViewChange: (view: ViewType) => void;
  view: ViewType;
  mapUrl: string;
  setChangeGoingOptionModalShow: Dispatch<SetStateAction<boolean>>;
  setChangeReturningOptionModalShow: Dispatch<SetStateAction<boolean>>;
  tickets: ValeTransp[];
  finalValue: number;
  predefinedOptions: TrajetosIda[],
  selectedGoingRoute: TrajetosIda,
  selectedReturningRoute: TrajetosVolum,
  changePredefinedOption: (predefinedOption: TrajetosIda) => Promise<void>;
  isManualRouting: boolean;
  errorMessage: string;
  setIsSomethingLoading: Dispatch<SetStateAction<boolean>>;
  canShowTicketsTab: boolean;
  canEnableActions: boolean;
  isConsultValid: boolean;
  handleSelectedSectionChange: (selectedSection: SectionOptionType) => void,
  sectionOptions: SectionOptionType[],
  selectedSection: SectionOptionType,
  isMultiRoute: boolean,
  allRoutes: TrajetoSelecaoIda[],
  statusRot: string,
  canShowMap: boolean,
  setMyLinkFullModalShow: Dispatch<SetStateAction<boolean>>,
}

export default function Result({
  canShowMap,
  goingRoute,
  returningRoute,
  resultHeaderWidth,
  otherGoingOptions,
  otherReturningOptions,
  handleViewChange,
  view,
  mapUrl,
  setChangeGoingOptionModalShow,
  setChangeReturningOptionModalShow,
  tickets,
  finalValue,
  predefinedOptions,
  selectedGoingRoute,
  selectedReturningRoute,
  changePredefinedOption,
  // isManualRouting,
  errorMessage,
  setIsSomethingLoading,
  canShowTicketsTab,
  canEnableActions,
  isConsultValid,
  handleSelectedSectionChange,
  sectionOptions,
  selectedSection,
  isMultiRoute,
  allRoutes,
  setMyLinkFullModalShow,
  // statusRot,
}: IResult) {
  // const totalVt = useMemo(() => (
  //   tickets.reduce((acc, cur) => (
  //     acc + cur.totVt
  //   ), 0)
  // ), [tickets]);

  const mapAllTimes = allRoutes.map((route) => route.tempoTj);
  const totalTime = mapAllTimes.reduce((acc, cur) => {
    if (cur) {
      return acc + cur;
    }

    return acc;
  }, 0);

  const { isCustomer } = useGetGeneralAppData();

  return (
    <Container>
      {!errorMessage && (
        <>
          <SidebarRoute
            goingRoute={goingRoute}
            returningRoute={returningRoute}
            tickets={tickets}
            view={view}
            otherGoingOptions={otherGoingOptions}
            otherReturningOptions={otherReturningOptions}
            handleViewChange={handleViewChange}
            setChangeGoingOptionModalShow={setChangeGoingOptionModalShow}
            setChangeReturningOptionModalShow={setChangeReturningOptionModalShow}
            canShowTicketsTab={canShowTicketsTab}
            isConsultValid={isConsultValid}
            handleSelectedSectionChange={handleSelectedSectionChange}
            sectionOptions={sectionOptions}
            selectedSection={selectedSection}
            totalVt={finalValue}
            isMultiRoute={isMultiRoute}
          />

          {(isConsultValid && canShowTicketsTab) && (
            <>
              {isMultiRoute ? (
                <GeneralSummary
                  resultHeaderWidth={resultHeaderWidth!}
                  totalPrice={finalValue}
                  totalTime={totalTime}
                />
              ) : (
                <PredefinedOptions
                  resultHeaderWidth={resultHeaderWidth!}
                  predefinedOptions={predefinedOptions}
                  selectedGoingRoute={selectedGoingRoute}
                  selectedReturningRoute={selectedReturningRoute}
                  changePredefinedOption={changePredefinedOption}
                  setIsLoading={setIsSomethingLoading}
                  canEnableActions={canEnableActions}
                />
              )}
            </>
          )}

          <MapContainer>
            {(canShowMap) ? (
              <iframe
                title="Mapa"
                src={`${mapUrl}&h=600&w=${(resultHeaderWidth ?? 1200) - 260}&z=12`}
                // src="https://mapas.captamobilidade.com.br/home/index?consulta=5472406&sentido=1&rota=1&trajeto=1&h=1320&w=980&z=12"
                width={(resultHeaderWidth ?? 1200) - 260}
                height={600}
                marginWidth={0}
                marginHeight={0}
                style={{ overflow: 'hidden' }}
              />
            ) : (
              <DefaultHereMap height={600} width={(resultHeaderWidth ?? 1200) - 260} />
            )}
          </MapContainer>
        </>
      )}

      {!!errorMessage && (
        <>
          <NoData
            icon="emptyBox"
            label={(
              <>
             Não encontramos nenhum resultado conforme os endereços e critérios de rota. Por favor, tente alterá-los, ou realize a roteirização manual.
            ({errorMessage})
                {(isCustomer && !isMultiRoute) && (
                  <SecondaryButton onClick={() => setMyLinkFullModalShow(true)}>
              Informar Bilhetes Manualmente
                  </SecondaryButton>
                )}
              </>
            )}
          />
        </>
      )}

    </Container>
  );
}
